// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__1uk2a","toggle":"toggle__2Ge_C","sidebar":"sidebar__2GK4B","sidebarInner":"sidebarInner__36t-z"};